import { render, staticRenderFns } from "./ReleaseNoteModal.vue?vue&type=template&id=12da7488&scoped=true"
import script from "./ReleaseNoteModal.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da7488",
  null
  
)

export default component.exports